// extracted by css-extract-rspack-plugin
export default {"cls1":"ArticlesFilters-cls1_oJW","cls2":"ArticlesFilters-cls2_vVQ ArticlesFilters-cls1_oJW"};